import React, { useRef, useState, useContext } from 'react'
import { components, constants, useServices } from 'cng-web-lib'
import { Chip } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ACEOceanTranslationContext } from '../contexts/ACEOceanTranslationContext'
import pathMap from 'src/paths/pathMap'
import AceOcnBillofladingApiUrls from 'src/apiUrls/AceOcnBillofladingApiUrls'
import Table from 'src/components/aciacehighway/Table'
import ConfirmDialog from 'src/views/common/ConfirmDialog'
import { getStatusMetadata } from '../../../common/NACommon'
import { FileForUserGetPartyId } from 'src/common/FileForUserCommon'
import TemplateSelectDialogWithOptionACEOCN from 'src/views/aceocean/billoflading/TemplateSelectDialogWithOptionACEOCN'

import moment from 'moment-timezone'
import _ from 'lodash'


const { filter: { EQUAL, IN, LIKE, BETWEEN } } = constants

function TablePage(props) {
  const { history, location, showNotification } = props
  const { deleteRecord } = useServices()
  const { getTranslatedText } = useContext(ACEOceanTranslationContext)
  const [billTemplateDialog, setBillTemplateDialog] = useState(false)

  const tableRef = useRef(null)

  const [confirmDelete, setConfirmDelete] = useState({ open: false, bol: null })
  const [confirmDialog, setConfirmDialog] = useState({ open: false, bol: null })
  const [confirmTemplateDialog, setConfirmTemplateDialog] = useState({ open: false, bol: null })



  const columns = [
    {
      field: 'billNumber',
      sortKey: 'billNumber',
      title: getTranslatedText('BOL', 'billNumber')
    },
    {
      field: 'oceanBillNumber',
      sortKey: 'oceanBillNumber',
      title: getTranslatedText('BOL', 'oceanBillNumber')
    },
    {
      field: 'vesselName',
      sortKey: 'vesselName',
      title: getTranslatedText('BOL', 'vesselName')
    },
    {
      field: 'voyageNumber',
      sortKey: 'voyageNumber',
      title: getTranslatedText('BOL', 'voyageNumber')
    },
    {
      field: 'etaDateArr',
      sortKey: 'etaDateArr',
      title: getTranslatedText('BOL', 'etaDateArr'),
      render: (data) => (moment(data.etaDateArr).tz('Canada/Eastern').format('D MMM YYYY, HH:mm'))
    },
    {
      field: 'createdDate',
      sortKey: 'createdDate',
      title: getTranslatedText('BOL', 'createdDate'),
      render: (data) => data.createdDate && moment(data.createdDate).tz('Canada/Eastern').format('D MMM YYYY, HH:mm')
    },
    {
      field: 'submittedDate',
      sortKey: 'submittedDate',
      title: getTranslatedText('BOL', 'submittedDate'),
      render: (data) => data.submittedDate && moment(data.submittedDate).tz('Canada/Eastern').format('D MMM YYYY, HH:mm')
    },
    {
      field: 'status',
      sortKey: 'status',
      title: getTranslatedText('BOL', 'status'),
      render: (data) => {
        const status = getStatusMetadata(data.status)

        return (
          <Chip label={status.label} size='small'
            style={{ backgroundColor: status.color, color: status.contrastColor }}
          />
        )
      }
    },
    {
      field: 'manifestId',
      sortKey: 'manifestId',
      title: getTranslatedText('BOL', 'manifestId')
    }
  ]

  const filters = [
    {
      label: getTranslatedText('BOL', 'billNumber'),
      type: 'textfield',
      name: 'billNumber',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('BOL', 'oceanBillNumber'),
      type: 'textfield',
      name: 'oceanBillNumber',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('BOL', 'vesselName'),
      type: 'textfield',
      name: 'vesselName',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('BOL', 'voyageNumber'),
      type: 'textfield',
      name: 'voyageNumber',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('BOL', 'etaDateArr'),
      type: 'daterange',
      name: 'etaDateArr',
      operatorType: BETWEEN
    },
    {
      label: getTranslatedText('BOL', 'createdDate'),
      type: 'daterange',
      name: 'createdDate',
      operatorType: BETWEEN
    },
    {
      label: getTranslatedText('BOL', 'submittedDate'),
      type: 'daterange',
      name: 'submittedDate',
      operatorType: BETWEEN
    },
    {
      label: getTranslatedText('BOL', 'status'),
      type: 'checkbox',
      name: 'status',
      operatorType: IN,
      options: [
        { label: 'Draft', value: 'draft', filterValue: { value: '1005' } },
        { label: 'Accepted', value: 'accepted', filterValue: { value: '1000' } },
        { label: 'Rejected', value: 'rejected', filterValue: { value: '1001' } },
        { label: 'Sent', value: 'sent', filterValue: { value: '1008' } },
        { label: 'Status Notification', value: 'status_notification', filterValue: { value: '1006' } },
        { label: 'Cancel', value: 'cancel', filterValue: { value: '1011' } },
      ]
    },
    {
      label: getTranslatedText('BOL', 'manifestId'),
      type: 'textfield',
      name: 'manifestId',
      operatorType: LIKE
    },
  ]

  function handleDeleteBOL() {
    if (!confirmDelete.bol) return

    setConfirmDelete({ open: false })

    deleteRecord.execute(AceOcnBillofladingApiUrls.DELETE, confirmDelete.bol,
      () => {
        showNotification('success', 'Delete succeeded')
        setConfirmDelete({ open: false, bol: null })
        tableRef.current.performRefresh()
      },
      (error) => { console.log(error) }
    )
  }
  
   function handleDeleteBOLTemplate() {
    if (!confirmTemplateDialog.bol) return
    setConfirmTemplateDialog({ open: false })
    deleteRecord.execute(AceOcnBillofladingApiUrls.DELETE, confirmTemplateDialog.bol,
      () => {
        showNotification('success', 'Delete succeeded')
        setConfirmTemplateDialog({ open: false, bol: null })
        setBillTemplateDialog(false)
      },
      (error) => { console.log(error) }
    )
  }

  function DisableEditButton(rowData) {
    return rowData.status == '1008'
  }

  function DisableDeleteButton(rowData) {
    return rowData.status != '1005' && rowData.status != '1002'
  }

  return (
    <>
      <Table
        actions={[
          {
            label: 'Create Bill of Lading',
            buttonProps: {
              color: 'primary', size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => history.push(pathMap.ACE_OCN_BILLOFLADING_ADD_VIEW)
            }
          },
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => setBillTemplateDialog(true)
            },
            label: 'ACEOCN bill Template'
          }
        ]}
        columns={columns}
        compact
        checkboxSelection
        fetch={{ url: AceOcnBillofladingApiUrls.GET }}
        fetchFilters={[
          { field: 'templateFlag', operator: EQUAL, value: '0' },
          { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() }
        ]}
        filters={filters}
        onRowClick={(rowData) => {
          if (DisableEditButton(rowData)) {
            history.push(`${location.pathname}/view/${rowData.id}`)
          } else {
            history.push(`${location.pathname}/edit/${rowData.id}`)
          }
        }}
        rowActions={[
          {
            label: getTranslatedText('BOL', 'editButton'),
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            disabled: (rowData) => DisableEditButton(rowData),
            onClick: (rowData) => history.push(`${location.pathname}/edit/${rowData.id}`),
            tooltip: (rowData) => DisableEditButton(rowData) ? 'Sent records cannot be Edited' : null
          },
          {
            label: getTranslatedText('BOL', 'deleteButton'),
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            disabled: (rowData) => DisableDeleteButton(rowData),
            onClick: (rowData) => setConfirmDelete({ open: true, bol: rowData }),
            tooltip: (rowData) => DisableDeleteButton(rowData) ? 'Only Draft records can be deleted' : null
          },
        ]}
        showNotification={showNotification}
        sortConfig={{ type: 'column', defaultField: 'createdDate', defaultDirection: 'DESC' }}
        persistSettings
        tableRef={tableRef}
        tablePreference={{ module: 'ACEOCN', key: 'bol_table_visible_column' }}
      />

      <ConfirmDialog
        isConfirmDialogOpen={confirmDelete.open}
        closeDialog={() => setConfirmDelete({ open: false, bol: null })}
        confirmDialog={handleDeleteBOL}
        content="Items that you delete can't be restored. Are you sure about this?"
        okMsg='Yes, delete'
        cancelMsg='No, take me back'
        title={getTranslatedText('BOL', 'deleteButton')}
      />
      <ConfirmDialog
        isConfirmDialogOpen={confirmTemplateDialog.open}
        closeDialog={() => setConfirmTemplateDialog({ open: false, bol: null })}
        confirmDialog={handleDeleteBOLTemplate}
        content="Items that you delete can't be restored. Are you sure about this?"
        okMsg='Yes, delete'
        cancelMsg='No, take me back'
        title={getTranslatedText('BOL', 'deleteButton')}
      />
      <TemplateSelectDialogWithOptionACEOCN
         manifestTemplateDialog={billTemplateDialog}
         setManifestTemplateDialog={setBillTemplateDialog}
         setConfirmDialog={setConfirmTemplateDialog}
         showNotification={showNotification}
         isTable={true}
         location={location}
        rowActions={[
          {
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: 'Edit',
            onClick: (rowData) =>
              history.push(pathMap.ACE_OCN_BILLOFLADING+`/edit/${rowData.id}`),
            tooltip: () => 'edit'
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            label: 'Delete',
            onClick: (rowData) =>
            setConfirmTemplateDialog({ open: true, bol: rowData }),
            tooltip: () => 'delete'
          }
        ]}
      />
    </>
  )
}

export default TablePage
